module.exports = __webpack_public_path__ + "img/容志行@2x.b1f0c306.png";